import { Logger } from "@tt-app/models";

export const MainLogger: Logger = {
  trace: (msg, args) => {
    if (args) {
      console.trace(msg, args);
    } else {
      console.trace(msg);
    }
  },
  debug: (msg, args) => {
    if (args) {
      console.debug(msg, args);
    } else {
      console.debug(msg);
    }
  },
  info: (msg, args) => {
    if (args) {
      console.log(msg, args);
    } else {
      console.log(msg);
    }
  },
  warn: (msg, args) => {
    if (args) {
      console.warn(msg, args);
    } else {
      console.warn(msg);
    }
  },
  error: (msg, args) => {
    if (args) {
      console.error(msg, args);
    } else {
      console.error(msg);
    }
  }
};
